import { WhyNeedRealtor } from '../../components/WhyNeedRealtor';
import {
  WHY_NEED_REALTOR_FIRST_ACCORDION_COLUMNS,
  WHY_NEED_REALTOR_SECOND_ACCORDION_COLUMNS,
  WHY_NEED_REALTOR_TITLE,
} from './constants';

export const WhyNeedRealtorContainer = () => {
  return (
    <WhyNeedRealtor
      title={WHY_NEED_REALTOR_TITLE}
      firstAccordionColumn={WHY_NEED_REALTOR_FIRST_ACCORDION_COLUMNS}
      secondAccordionColumn={WHY_NEED_REALTOR_SECOND_ACCORDION_COLUMNS}
    />
  );
};
